import _sectionClasses from './Page/Sections/index';
import _buttonClasses from '../DefaultButtons';

_buttonClasses.push({
  classes: ['btn', 'btn-start'],
  type: 'start',
  style: {color: '#FFF'},
  background: {
    color: 'transparent'
  }
});

export {_sectionClasses, _buttonClasses};
